import { useRef, useEffect } from 'react';
import { sessionAttributionTracker } from './sessionAttributionTracker';

/**
 * Hook for session activity timer.
 * Use ONLY in root layout to:
 * 1. Initialize session on mount
 * 2. Run periodic activity heartbeat timer to keep session alive
 */

// Activity update interval: 1 minute in milliseconds
const ACTIVITY_UPDATE_INTERVAL_MS = 1 * 60 * 1000;

export function useSessionAttributionTrackingTimer() {
  const isInitialized = useRef(false);

  // Initialize on mount
  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;
    sessionAttributionTracker.initSession();
  }, []);

  // Periodically update last activity to keep session alive
  useEffect(() => {
    const interval = setInterval(() => {
      sessionAttributionTracker.updateLastActivity();
    }, ACTIVITY_UPDATE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);
}
